import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import SpeakerCard from '../components/speaker-card.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const Event = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState(location.state?.id);
    const setContext = useContext(Context)[1];
    const { role, metaData, firstName, lastName } = useContext(AccessContext);
    var _s = undefined;
    if (role == "Host/Guest")
        _s = { id: metaData.speakerId, firstName, lastName };
    if (id)
        setContext('Edit Event');
    else
        setContext('Add Event');
    const formatDateTime = (d) => {
        let year = d.getFullYear();
        let month = String(d.getMonth() + 1).padStart(2, '0');
        let day = String(d.getDate()).padStart(2, '0');
        let hours = String(d.getHours()).padStart(2, '0');
        let minutes = String(d.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    const defaultEvent = {
        title: '',
        location: '',
        cityState: '',
        ticketUrl: '',
        soldOut: false,
        datetime: formatDateTime(new Date()),
        hosts: location.state?.speaker ? [location.state?.speaker] : (_s ? [_s] : []),
        guests: []
    }
    const [event, setEvent] = useState(defaultEvent);
    useEffect(() => {
        if (!id) {
            setEvent(defaultEvent);
        }
    },[role]);
    const [loading, setLoading] = useState(id ? true : false);
    const [hosts, setHosts] = useState([]);
    const [guests, setGuests] = useState([]);
    const [hostId, setHostId] = useState(-1);
    const [guestId, setGuestId] = useState(-1);
    const loadEvent = () => {
        axios.post(process.env.REACT_APP_API_URL + 'event', {
            id: id
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setEvent(r.data.results);
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadEvent();
        } else {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        /*axios.post(process.env.REACT_APP_API_URL + 'host').then(r => {
            if (r?.data?.status === 'Success') {
                setHosts(r.data.results);
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'guest').then(r => {
            if (r?.data?.status === 'Success') {
                setGuests(r.data.results);
            }
        });*/
    }, []);
    const setValue =(key, value) => {
        setEvent(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const save = () => {
        if (!id) {
            axios.post(process.env.REACT_APP_API_URL + 'event/add', {
                title: event.title,
                location: event.location,
                cityState: event.cityState,
                ticketUrl: event.ticketUrl,
                soldOut: event.soldOut,
                datetime: event.datetime ? event.datetime : '',
                hosts: JSON.stringify((event.hosts || []).map(h => h.id)),
                guests: JSON.stringify((event.guests || []).map(g => g.id))
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setLoading(true);
                }
            });
        } else {
            axios.post(process.env.REACT_APP_API_URL + 'event/update', {
                id: id,
                title: event.title,
                location: event.location,
                cityState: event.cityState,
                ticketUrl: event.ticketUrl,
                soldOut: event.soldOut,
                datetime: event.datetime ? event.datetime : '',
                hosts: JSON.stringify((event.hosts || []).map(h => h.id)),
                guests: JSON.stringify((event.guests || []).map(g => g.id))
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setLoading(true);
                    loadEvent();
                }
            });
        }
    }
    const _delete = () => {
        if (!id)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'event/delete', {
            ids: JSON.stringify([id])
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                navigate('/event-list');
            }
        });
    }
    const filterArrays = (arrA, arrB) => {
        return (arrA || []).filter(a => {
            return !(arrB || []).some(b => {
                return a.id === b.id;
            });
        });
    }
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form speaker-form f-start">
                    <div className="flex mb-0 f-between a-center f-row">
                        <h3 className="mb-0">Event Info</h3>
                        <div className="flex gap-10 f-row a-center grow-0">
                            <label htmlFor="sold-out" className="mb-0">Event Sold Out</label>
                            <input type="checkbox" id="sold-out" checked={event.soldOut} onChange={e => setValue('soldOut', e.target.checked)} />
                        </div>
                    </div>
                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white">
                        <div className="w-100 gap-10 f-row f-wrap">
                            <div className="w-100">
                                <label htmlFor="title">Title</label>
                                <input type="text" id="title" value={event.title} onChange={(e) => setValue('title', e.target.value)} />
                            </div>
                            <div className="w-50">
                                <label htmlFor="location">Location</label>
                                <input type="text" id="location" value={event.location} onChange={(e) => setValue('location', e.target.value)} />
                            </div>
                            <div className="w-50">
                                <label htmlFor="city-state">City/State</label>
                                <input type="text" id="city-state" value={event.cityState} onChange={(e) => setValue('cityState', e.target.value)} />
                            </div>
                            <div className="w-50">
                                <label htmlFor="ticket">Ticket Url</label>
                                <input type="text" id="ticket" value={event.ticketUrl} onChange={(e) => setValue('ticketUrl', e.target.value)} />
                            </div>
                            <div className="w-50">
                                <label htmlFor="datetime">Date & Time</label>
                                <input id="datetime" type="datetime-local" value={formatDateTime(new Date(event.datetime || new Date()))} onChange={(e) => setValue('datetime', e.target.value)} />
                            </div>
                        </div>
                    </div>

                    {false && (<><div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white">
                        <h3 className="mb-10">Hosts</h3>
                        <div className="f-start f-row mt-5 mb-10">
                            <Link to="/host">Create New Host</Link>
                        </div>
                        {hosts?.length > 0 && (
                            <div className="w-100">
                                <label htmlFor="find-host">Add Host</label>
                                <div className="w-100 gap-10 f-row mb-10">
                                    <select id="find-host" className="w-100" onChange={(e) => setHostId(e.target.value)} value={hostId}>
                                        <option value={-1}>
                                            Please Select...
                                        </option>
                                        {filterArrays(hosts, event.hosts).map((e, i) => (
                                            <option key={i} value={e.id}>
                                                {e.id}: {e.firstName} {e.lastName}
                                            </option>
                                        ))}
                                    </select>
                                    <button className="btn" onClick={() => {
                                        if (hostId == -1)
                                            return;
                                        var host = hosts.find(e => e.id == hostId);
                                        if (!host)
                                            return;
                                        setEvent(_e => {
                                            let e = { ..._e };
                                            e.hosts = e.hosts || [];
                                            e.hosts.push(host);
                                            setHostId(-1);
                                            return e;
                                        });
                                    }}> Add</button>
                                </div>
                            </div>
                        )}
                        <div className="w-100 gap-10 card-container">
                            {event.hosts?.length ? event.hosts.map((h, i) => {
                                return (
                                    <SpeakerCard speaker={h} onRemove={(_id) => {
                                        var index = event.hosts.findIndex(h => h.id == _id);
                                        if (index < 0)
                                            return;
                                        setEvent(_e => {
                                            let e = { ..._e };
                                            e.hosts.splice(index, 1);
                                            return e;
                                        });
                                    }} key={i} />
                                );
                            }) : (
                                <div className="text-center">No Hosts</div>
                            )}
                        </div>
                    </div>

                    <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel">
                        <h3 className="mb-10">Guests</h3>
                        <div className="f-start f-row mt-5 mb-10">
                            <Link to="/guest">Create New Guest</Link>
                        </div>
                        {guests?.length > 0 && (
                            <div className="w-100">
                                <label htmlFor="find-guest">Add Guest</label>
                                <div className="w-100 gap-10 f-row mb-10">
                                    <select id="find-guest" className="w-100" onChange={(e) => setGuestId(e.target.value)} value={guestId}>
                                        <option value={-1}>
                                            Please Select...
                                        </option>
                                        {filterArrays(guests, event.guests).map((e, i) => (
                                            <option key={i} value={e.id}>
                                                {e.id}: {e.firstName} {e.lastName}
                                            </option>
                                        ))}
                                    </select>
                                    <button className="btn" onClick={() => {
                                        if (guestId == -1)
                                            return;
                                        var guest = guests.find(e => e.id == guestId);
                                        if (!guest)
                                            return;
                                        setEvent(_e => {
                                            let e = { ..._e };
                                            e.guests = e.guests || [];
                                            e.guests.push(guest);
                                            setGuestId(-1);
                                            return e;
                                        });
                                    }}> Add</button>
                                </div>
                            </div>
                        )}
                        <div className="w-100 gap-10 card-container">
                            {event.guests?.length ? event.guests.map((h, i) => {
                                return (
                                    <SpeakerCard speaker={h} onRemove={(_id) => {
                                        var index = event.guests.findIndex(h => h.id == _id);
                                        if (index < 0)
                                            return;
                                        setEvent(_e => {
                                            let e = { ..._e };
                                            e.guests.splice(index, 1);
                                            return e;
                                        });
                                    }} key={i} />
                                );
                            }) : (
                                <div className="text-center">No Guests</div>
                            )}
                        </div>
                    </div></>)}

                    <div className="w-100 f-end f-row" style={{ order: 10 }}>
                        <div className="flex f-center f-row gap-5">
                            <button onClick={save} className="btn btn-green">{id ? "Update Event" : "Create Event"}</button>
                            {id && <button onClick={() => {
                                setId(null);
                                setEvent(defaultEvent);
                                setLoading(true);
                            }} className="btn">New</button>}
                            <Link className="btn btn-red" to={location.state?.returnTo ? location.state?.returnTo : "/event-list"} state={location.state?.speaker ? {id: location.state?.speaker.id} : null}>Cancel</Link>
                            {id && <button onClick={_delete} className="btn btn-red">Delete</button>}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Event;